var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.moduleInstances),function(moduleInstance){return _c('ProductPartnerAdvantagesImplModule',{attrs:{"instance":moduleInstance,"backgroundColor":moduleInstance['advantage1']['color'],"partnerAdvantages":moduleInstance['advantage1'],"modelAdvantages":moduleInstance['advantage2']}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }